export const PRIMARY_COLORS = ["red", "blue", "yellow"] as const;
export const SECONDARY_COLORS = ["purple", "green", "orange"] as const;

export type PrimaryColor = (typeof PRIMARY_COLORS)[number];
export type SecondaryColor = (typeof SECONDARY_COLORS)[number];
export type GameColor = PrimaryColor | SecondaryColor;

export type Rgb = [number, number, number];

export interface ColorDef {
    name: string;
    rgb: Rgb;
}

export interface GameOverStats {
    score: number;
    barriersPassed: number;
    maxCombo: number;
}
